import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserProfileService } from '../services';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class IsWebAdminGuard implements CanActivate {

    constructor(
        private profileService: UserProfileService,
        private router: Router) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        return Observable.create((observer: any) => {
            this.profileService.getUserProfile().subscribe(res => {
                if(res && res.webAdmin) {
                    observer.next(true);
                } else if (res && !res.webAdmin && state.url.startsWith('/report')) {
                    observer.next(true);
                } else {
                    this.router.navigate(['/report/employee'], { replaceUrl: true });
                    observer.next(false);
                }
                observer.complete();
            });
        });
    }
}
